<ng-container *ngIf="shouldShowArrowButtons">
    <div class="icon-wrapper" (click)="scrollLeft()">
        <mat-icon
            data-cy="scroll-arrow-left"
            class="arrow-icon left-icon"
            svgIcon="chevron"
        />
    </div>
</ng-container>
<div
    [ngClass]="[
        'scroll-wrapper',
        responsive.deviceAndOrientation,
        responsive.screenSize,
    ]"
    #scrollContainer
>
    <div *ngIf="showDefaultItem">
        <a
            data-cy="scroll-default-item"
            class="scroll-item"
            [ngClass]="{ 'activeItem': isActiveItem() }"
            [routerLink]="defaultItem.routerLink"
        >
            {{ defaultItem.displayName | translate }}
        </a>
    </div>
    <div class="scroll-item-container" *ngFor="let item of items; index as i">
        <a
            data-cy="scroll-item"
            class="scroll-item"
            [ngClass]="{ 'activeItem': isActiveItem(i, item) }"
            routerLinkActive="active"
            [routerLink]="routerLinks[i]"
        >
            {{ item.displayName || item.name || item.title }}
        </a>
    </div>
</div>

<div
    class="icon-wrapper"
    *ngIf="shouldShowArrowButtons"
    (click)="scrollRight()"
>
    <mat-icon
        data-cy="scroll-arrow-right"
        class="arrow-icon right-icon"
        svgIcon="chevron"
    />
</div>
